<form class="solicitacao">
  @if (store.erroEnvio(); as erro) {
    <div class="solicitacao-alerta-api" role="alert" tabindex="-1" #blocoErro>
      <i-lucide name="circle-x" size="18" aria-hidden="true"></i-lucide>

      <div>
        <p class="solicitacao-alerta-api-titulo">{{ erro.mensagem }}</p>

        @if (erro.detalhes.length) {
          <ul class="solicitacao-alerta-api-lista">
            @for (detalhe of erro.detalhes; track detalhe) {
              <li>{{ detalhe }}</li>
            }
          </ul>
        }
      </div>
    </div>
  }

  @if (mostrarPendencias() && !store.valido()) {
    <p class="solicitacao-aviso" role="alert">
      <i-lucide name="circle-alert" size="18" aria-hidden="true"></i-lucide>
      Preencha os campos obrigatórios destacados para avançar.
    </p>
  }

  @if (store.identificado()) {
    <section class="solicitacao-cartao" aria-labelledby="solicitacao-pessoais-titulo">
      <h2 class="solicitacao-cartao-titulo" id="solicitacao-pessoais-titulo">Dados pessoais</h2>

      <p class="solicitacao-aviso-dados">
        <i-lucide name="info" size="16" aria-hidden="true"></i-lucide>
        <span>
          É por estes dados que a Ouvidoria responde. Confira e corrija o que estiver desatualizado
          — a alteração vale só para esta manifestação.
        </span>
      </p>

      <div class="solicitacao-campo">
        <label class="solicitacao-rotulo" for="solicitacao-nome">Nome completo*</label>
        <input
          id="solicitacao-nome"
          class="solicitacao-input"
          type="text"
          autocomplete="name"
          placeholder="Digite seu nome completo"
          [attr.aria-invalid]="store.solicitacaoForm.nomeCompleto().invalid()"
          [attr.aria-describedby]="
            store.solicitacaoForm.nomeCompleto().invalid() ? 'solicitacao-nome-erro' : null
          "
          [formField]="store.solicitacaoForm.nomeCompleto"
        />
        @if (
          store.solicitacaoForm.nomeCompleto().touched() &&
          store.solicitacaoForm.nomeCompleto().invalid()
        ) {
          <p class="solicitacao-erro" id="solicitacao-nome-erro">Campo obrigatório.</p>
        }
      </div>

      <div class="solicitacao-linha solicitacao-linha-local">
        <div class="solicitacao-campo">
          <label class="solicitacao-rotulo" for="solicitacao-cpf">CPF / CNPJ</label>
          <input
            id="solicitacao-cpf"
            class="solicitacao-input"
            type="text"
            inputmode="numeric"
            placeholder="000.000.000-00"
            [mask]="mascaraDocumento"
            [attr.aria-invalid]="store.solicitacaoForm.cpfCnpj().invalid()"
            [attr.aria-describedby]="
              store.solicitacaoForm.cpfCnpj().invalid() ? 'solicitacao-cpf-erro' : null
            "
            [formField]="store.solicitacaoForm.cpfCnpj"
          />
          @if (
            store.solicitacaoForm.cpfCnpj().touched() && store.solicitacaoForm.cpfCnpj().invalid()
          ) {
            <p class="solicitacao-erro" id="solicitacao-cpf-erro">Informe um CPF ou CNPJ válido.</p>
          }
        </div>

        <div class="solicitacao-campo">
          <label class="solicitacao-rotulo" for="solicitacao-telefone">Telefone</label>
          <input
            id="solicitacao-telefone"
            class="solicitacao-input"
            type="tel"
            inputmode="tel"
            autocomplete="tel"
            placeholder="(71) 00000-0000"
            [mask]="mascaraTelefone"
            [formField]="store.solicitacaoForm.telefone"
          />
        </div>
      </div>

      <div class="solicitacao-campo">
        <label class="solicitacao-rotulo" for="solicitacao-email">E-mail*</label>
        <input
          id="solicitacao-email"
          class="solicitacao-input"
          type="email"
          autocomplete="email"
          placeholder="seuemail@exemplo.com"
          [attr.aria-invalid]="store.solicitacaoForm.email().invalid()"
          [attr.aria-describedby]="
            store.solicitacaoForm.email().invalid() ? 'solicitacao-email-erro' : null
          "
          [formField]="store.solicitacaoForm.email"
        />
        @if (store.solicitacaoForm.email().touched() && store.solicitacaoForm.email().invalid()) {
          <p class="solicitacao-erro" id="solicitacao-email-erro">Informe um e-mail válido.</p>
        }
      </div>
    </section>
  }

  <section class="solicitacao-cartao" aria-labelledby="solicitacao-endereco-titulo">
    <h2 class="solicitacao-cartao-titulo" id="solicitacao-endereco-titulo">
      Endereço relacionado à manifestação
    </h2>

    <p class="solicitacao-texto">
      Opcional. Informe quando o fato tiver um lugar — é o que ajuda a Ouvidoria a acionar o setor
      certo.
    </p>

    <div class="solicitacao-campo">
      <label class="solicitacao-rotulo" for="solicitacao-endereco">Endereço</label>
      <input
        id="solicitacao-endereco"
        class="solicitacao-input"
        type="text"
        autocomplete="street-address"
        placeholder="Ex.: Rua das Flores, 120, Bloco B"
        [formField]="store.solicitacaoForm.endereco"
      />
    </div>

    <div class="solicitacao-linha solicitacao-linha-complemento">
      <div class="solicitacao-campo">
        <label class="solicitacao-rotulo" for="solicitacao-bairro">Bairro</label>
        <input
          id="solicitacao-bairro"
          class="solicitacao-input"
          type="text"
          placeholder="Ex.: Centro, Itapuã..."
          [formField]="store.solicitacaoForm.bairro"
        />
      </div>

      <div class="solicitacao-campo">
        <label class="solicitacao-rotulo" for="solicitacao-cidade">Cidade</label>
        <input
          id="solicitacao-cidade"
          class="solicitacao-input"
          type="text"
          autocomplete="address-level2"
          placeholder="Ex.: Salvador"
          [formField]="store.solicitacaoForm.cidade"
        />
      </div>

      <div class="solicitacao-campo">
        <label class="solicitacao-rotulo" for="solicitacao-uf">UF</label>
        <div class="solicitacao-select-caixa">
          <select
            id="solicitacao-uf"
            class="solicitacao-input"
            [formField]="store.solicitacaoForm.uf"
          >
            <option value="">Selecione</option>
            @for (uf of ufs; track uf) {
              <option [value]="uf">{{ uf }}</option>
            }
          </select>

          <i-lucide
            class="solicitacao-select-seta"
            name="chevron-down"
            size="18"
            aria-hidden="true"
          ></i-lucide>
        </div>
      </div>
    </div>
  </section>

  <section class="solicitacao-cartao" aria-labelledby="solicitacao-manifestacao-titulo">
    <h2 class="solicitacao-cartao-titulo" id="solicitacao-manifestacao-titulo">Manifestação</h2>

    <div class="solicitacao-campo">
      <label class="solicitacao-rotulo" for="solicitacao-assunto">Assunto*</label>
      <input
        id="solicitacao-assunto"
        class="solicitacao-input"
        type="text"
        placeholder="Resuma sua manifestação em uma frase"
        [attr.aria-invalid]="store.solicitacaoForm.assunto().invalid()"
        [attr.aria-describedby]="
          store.solicitacaoForm.assunto().invalid() ? 'solicitacao-assunto-erro' : null
        "
        [formField]="store.solicitacaoForm.assunto"
      />

      <p class="solicitacao-contador" aria-live="polite">
        {{ store.caracteresAssunto() }}/{{ limiteAssunto }}
      </p>

      @if (store.solicitacaoForm.assunto().touched() && store.solicitacaoForm.assunto().invalid()) {
        <p class="solicitacao-erro" id="solicitacao-assunto-erro">Campo obrigatório.</p>
      }
    </div>

    <p class="solicitacao-texto">
      Para que a Ouvidoria possa acionar o órgão responsável de forma eficiente, é fundamental que
      você descreva detalhadamente sua manifestação, fornecendo informações sobre o que aconteceu,
      como ocorreu, onde, quando e, quando aplicável, quem foi o responsável pela ocorrência.
    </p>

    <div class="solicitacao-campo">
      <label class="solicitacao-rotulo" for="solicitacao-descricao">{{ rotuloDescricao() }}*</label>
      <textarea
        id="solicitacao-descricao"
        class="solicitacao-input solicitacao-textarea"
        rows="5"
        [placeholder]="placeholderDescricao()"
        [attr.aria-invalid]="store.solicitacaoForm.descricao().invalid()"
        [attr.aria-describedby]="
          store.solicitacaoForm.descricao().invalid() ? 'solicitacao-descricao-erro' : null
        "
        [formField]="store.solicitacaoForm.descricao"
      ></textarea>

      <p class="solicitacao-contador" aria-live="polite">
        {{ store.caracteresDescricao() }}/{{ limiteDescricao }}
      </p>

      @if (
        store.solicitacaoForm.descricao().touched() && store.solicitacaoForm.descricao().invalid()
      ) {
        <p class="solicitacao-erro" id="solicitacao-descricao-erro">Campo obrigatório.</p>
      }
    </div>

    @if (ouvidoria.permiteAnexo()) {
      <div class="solicitacao-campo">
        <span class="solicitacao-rotulo" id="solicitacao-anexos-rotulo">Anexos</span>

        <label
          class="solicitacao-anexos"
          [attr.data-arrastando]="arrastando()"
          (dragover)="aoArrastar($event)"
          (dragleave)="aoSairDaArea()"
          (drop)="aoSoltar($event)"
        >
          <input
            class="solicitacao-anexos-campo"
            type="file"
            multiple
            accept="image/*,.pdf,.doc,.docx"
            aria-labelledby="solicitacao-anexos-rotulo"
            (change)="aoSelecionar($event)"
          />

          <i-lucide
            class="solicitacao-anexos-icone"
            name="upload"
            size="26"
            aria-hidden="true"
          ></i-lucide>

          <span class="solicitacao-anexos-titulo">
            @if (store.arquivos().length) {
              {{ store.arquivos().length }} arquivo(s) escolhido(s)
            } @else {
              Nenhum arquivo escolhido
            }
          </span>

          <span class="solicitacao-anexos-texto">
            Arraste e solte ou clique para selecionar arquivos
          </span>
        </label>

        @if (store.arquivos().length) {
          <ul class="solicitacao-anexos-lista">
            @for (arquivo of store.arquivos(); track arquivo.id) {
              <li class="solicitacao-anexos-item">
                <span class="solicitacao-anexos-nome">
                  <i-lucide name="paperclip" size="16" aria-hidden="true"></i-lucide>
                  {{ arquivo.nome }}
                </span>

                <span class="solicitacao-anexos-tamanho">{{
                  formatarTamanho(arquivo.tamanho)
                }}</span>

                <button
                  type="button"
                  class="solicitacao-anexos-remover"
                  [attr.aria-label]="'Remover ' + arquivo.nome"
                  (click)="remover(arquivo.id)"
                >
                  <i-lucide name="trash-2" size="16" aria-hidden="true"></i-lucide>
                </button>
              </li>
            }
          </ul>
        }
      </div>
    }
  </section>

  <section class="solicitacao-cartao" aria-labelledby="solicitacao-resposta-titulo">
    <h2 class="solicitacao-cartao-titulo" id="solicitacao-resposta-titulo">
      Resposta e privacidade
    </h2>

    <div class="solicitacao-toggle">
      <input
        id="solicitacao-deseja-resposta"
        class="solicitacao-toggle-campo"
        type="checkbox"
        [checked]="store.dados().desejaResposta"
        (change)="alternarDesejaResposta($event)"
      />
      <label class="solicitacao-toggle-rotulo" for="solicitacao-deseja-resposta">
        Desejo receber uma resposta desta manifestação
      </label>
    </div>

    <div class="solicitacao-campo">
      <label class="solicitacao-rotulo" for="solicitacao-forma-resposta">
        Como você quer receber a resposta?*
      </label>
      <div class="solicitacao-select-caixa">
        <select
          id="solicitacao-forma-resposta"
          class="solicitacao-input"
          [attr.aria-invalid]="store.solicitacaoForm.formaResposta().invalid()"
          [formField]="store.solicitacaoForm.formaResposta"
        >
          @for (forma of formasResposta; track forma.chave) {
            <option [value]="forma.chave">{{ forma.rotulo }}</option>
          }
        </select>

        <i-lucide
          class="solicitacao-select-seta"
          name="chevron-down"
          size="18"
          aria-hidden="true"
        ></i-lucide>
      </div>
    </div>

    @if (store.identificado() && ouvidoria.permiteSigilo()) {
      <div class="solicitacao-toggle">
        <input
          id="solicitacao-sigilo"
          class="solicitacao-toggle-campo"
          type="checkbox"
          aria-describedby="solicitacao-sigilo-apoio"
          [checked]="store.dados().sigiloIdentidade"
          (change)="alternarSigilo($event)"
        />
        <label class="solicitacao-toggle-rotulo" for="solicitacao-sigilo">
          Manter minha identidade em sigilo perante o setor
        </label>
      </div>

      <p class="solicitacao-apoio" id="solicitacao-sigilo-apoio">
        O sigilo preserva sua identidade perante o setor responsável pela apuração — a Ouvidoria
        continua sabendo quem você é, porque é ela quem responde a você.
      </p>
    }

    <div class="solicitacao-toggle">
      <input
        id="solicitacao-aceite"
        class="solicitacao-toggle-campo"
        type="checkbox"
        [checked]="store.dados().aceiteComunicacao"
        [attr.aria-invalid]="store.solicitacaoForm.aceiteComunicacao().invalid()"
        [attr.aria-describedby]="
          store.solicitacaoForm.aceiteComunicacao().invalid() ? 'solicitacao-aceite-erro' : null
        "
        (change)="alternarAceite($event)"
      />
      <label class="solicitacao-toggle-rotulo" for="solicitacao-aceite">
        Aceito ser contatado pela Ouvidoria sobre esta manifestação*
      </label>
    </div>

    @if (
      store.solicitacaoForm.aceiteComunicacao().touched() &&
      store.solicitacaoForm.aceiteComunicacao().invalid()
    ) {
      <p class="solicitacao-erro" id="solicitacao-aceite-erro">
        É necessário aceitar o contato para registrar a manifestação.
      </p>
    }

    <p class="solicitacao-texto solicitacao-texto-forte">
      Os campos indicados com asterisco (*) são de preenchimento obrigatório.
    </p>
  </section>

  <!-- Invisível para quem usa a tela; o robô que lê o HTML preenche (anti-abuso). -->
  <app-campo-honeypot [(valor)]="store.desafio.honeypot" />
</form>
